import { OFF_ATTRIBUTE_VALUE } from "./installerHasFullWeekOff";

// - - - - - - - - - -
// #182 + #183 + #186 — which installer-day cells may be LOCKED.
//
// A cell is lockable when it is NOT an OFF day AND it's an "intentional" day —
// it has scheduled work OR a non-OFF designation (BUFFER / Custom / etc.):
//   • #182 — a fully-AVAILABLE day (no jobs AND no designation) can't be
//     locked; locking signals "done filling this day," meaningless when the
//     day is wide open.
//   • #183 (follow-up) — a BUFFER day (or any non-OFF designation) IS lockable
//     EVEN WITH NO JOBS. A designation is an intentional marking, not "fully
//     available." (My original #182 guard wrongly greyed out empty BUFFER days.)
//   • #186 — an OFF day can't be locked (regardless of jobs/designation).
//
// "Designation" = an Attribute doc with a non-empty encodedSmallTitle that
// isn't OFF (e.g. "BUFFER", a 🔥Custom🔥 label). A bare locked attribute has an
// EMPTY encodedSmallTitle, so it is NOT a designation — but such cells always
// have jobs (you can only lock a no-designation day when it has jobs), so they
// stay lockable via hasJobs.
//
// Pure + tested so the right-click menu guard and any data-layer guard agree.
// Note: UNLOCK is intentionally NOT gated by this (so a stray lock can always
// be cleared); only the LOCK action is blocked when !lockable.

/**
 * @param {Array}  scheduleArray - projected per-week schedule (job tiles +
 *                                 attribute docs). Job tiles have
 *                                 `attribute !== true`; attribute docs (OFF /
 *                                 BUFFER / Custom / lock) have `attribute === true`.
 * @param {string} payrollNo     - normalized installer payrollNo (matches `installer`)
 * @param {string} date          - cell date string (matches `start`)
 * @returns {{ hasJobs: boolean, isOffDay: boolean, hasDesignation: boolean, lockable: boolean }}
 */
export function getCellLockEligibility(scheduleArray, payrollNo, date) {
  const result = {
    hasJobs: false,
    isOffDay: false,
    hasDesignation: false,
    lockable: false,
  };
  if (!Array.isArray(scheduleArray) || !payrollNo || !date) return result;

  for (const doc of scheduleArray) {
    if (!doc || doc.installer !== payrollNo || doc.start !== date) continue;
    if (doc.attribute === true) {
      const enc = doc.encodedSmallTitle;
      if (enc === OFF_ATTRIBUTE_VALUE) {
        result.isOffDay = true;
      } else if (typeof enc === "string" && enc.trim() !== "") {
        // BUFFER / 🔥Custom🔥 / etc. — an intentional, non-OFF marking.
        result.hasDesignation = true;
      }
    } else {
      result.hasJobs = true;
    }
  }
  result.lockable =
    !result.isOffDay && (result.hasJobs || result.hasDesignation);
  return result;
}

export default getCellLockEligibility;
